var map = {
	"./pr-1.png": "ce1f",
	"./pr-10.png": "78ce",
	"./pr-11.png": "13a5",
	"./pr-12.png": "4add",
	"./pr-13.png": "6a2c",
	"./pr-14.png": "decf",
	"./pr-15.png": "a726",
	"./pr-16.png": "2508",
	"./pr-2.png": "4dbb",
	"./pr-3.png": "77eb",
	"./pr-4.png": "b99f",
	"./pr-5.png": "e67a",
	"./pr-6.png": "d695",
	"./pr-7.png": "4824",
	"./pr-8.png": "cb90",
	"./pr-9.png": "c7ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1bdc";